module.exports = __webpack_public_path__ + "static/media/tyme-bank-credit-card.c94c11ca.svg";